<!-- 订单列表 -->
<template>
  <div class="basicStyle">
    <div class="bg_fff">
      <div class="querySearch">
        <div class="searchItem">
          <span>状态</span>
          <el-select v-model="queryInfo.status" size="small" class="w100Select">
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="待审核" :value="0"></el-option>
            <el-option label="已通过" :value="1"></el-option>
            <el-option label="未通过" :value="2"></el-option>
          </el-select>
        </div>
        <div class="searchItem">
          <span>订单号</span>
          <el-input
            v-model="queryInfo.order_no"
            clearable
            size="small"
            placeholder="请输入订单号"
          ></el-input>
        </div>
        <div class="searchItem">
          <span>用户信息</span>
          <el-input
            v-model="queryInfo.username"
            clearable
            size="small"
            placeholder="请输入学员账号或者手机号"
          ></el-input>
        </div>
        <div class="searchItem">
          <span>商品名称</span>
          <el-input
            v-model="queryInfo.good_name"
            clearable
            size="small"
            placeholder="请输入商品名称"
          ></el-input>
        </div>
        <div class="searchItem">
          <span>申请时间</span>
          <el-date-picker
            v-model="timeFrame"
            size="small"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            @change="selectData"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>

        <div v-if="subjectOptions.length > 1" class="searchItem">
          <span>所属考试</span>
          <el-select
            v-model="subject_cate_ids"
            size="small"
            clearable
            multiple
            collapse-tags
            placeholder="请选择所属考试"
          >
            <el-option
              v-for="item in subjectOptions"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
            <!-- <el-option label="高职单招" :value="1399"></el-option>
          <el-option label="成考专升本" :value="289"></el-option>
          <el-option label="成考高起专" :value="352"></el-option> -->
          </el-select>
        </div>
        <div class="searchItem">
          <!-- <el-button type="primary" size="small" @click="queryTable('search')"
          >搜索</el-button
        >
        <el-button type="warning" size="small" @click="resetQuery"
          >重置</el-button
        > -->

          <MyButton
            value="搜索"
            size="medium"
            icon="el-icon-search"
            type="1"
            @click="queryTable('search')"
          ></MyButton>
          <MyButton
            value="重置"
            size="medium"
            type="2"
            @click="resetQuery"
          ></MyButton>
        </div>
      </div>
      <div class="table">
        <TableComponents
          :columns="columns"
          :tableData="tableList"
          :tableFunction="tableFunction"
        >
          <template slot="operation" slot-scope="{ row }">
            <div>{{ row.un_remarks }}</div>
            <div
              v-if="row.status == 1 && row.is_show_flowing == 1"
              style="color: #846ffd; cursor: pointer"
              @click="skipFinal(row)"
            >
              查看退款流水
            </div>
          </template>
        </TableComponents>
      </div>
      <!-- <h5>总订单<span>{{queryInfo.total}}</span>条、已支付订单<span>{{allInfo.pay_count}}</span>条、实付总金额<span>{{allInfo.pay_fee}}</span>元、总退款金额<span>{{allInfo.refund_fee}}</span>元</h5> -->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.page"
          :page-sizes="[10, 30, 50, 80]"
          :page-size="queryInfo.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryInfo.total"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 编辑弹窗 -->
    <el-dialog
      :title="dialogType"
      :visible.sync="addFormShow"
      class="formDialog"
      width="500px"
    >
      <div>
        <div class="orderD" v-if="!userCustomShow">
          <span>订单号：</span>
          <div>{{ userInfo.order_no }}</div>
        </div>
        <div class="orderD" v-if="!userCustomShow">
          <span>所属机构：</span>
          <div>{{ userInfo.order_no }}</div>
        </div>
        <div class="orderD" v-if="!userCustomShow">
          <span>开通人：</span>
          <div>{{ userInfo.qgroup.name }}</div>
        </div>
        <div class="orderD">
          <span>商品名称：</span>
          <div>{{ userInfo.good_name }}</div>
        </div>
        <div class="orderD" v-if="!userCustomShow">
          <span>订单总价：</span>
          <div>{{ userInfo.fee }}</div>
        </div>
        <div class="orderD">
          <span>实付金额：</span>
          <div>{{ userInfo.fees }}</div>
        </div>
        <div class="orderD" v-if="!userCustomShow">
          <span>创建时间：</span>
          <div>{{ userInfo.created_at }}</div>
        </div>
        <div class="orderD" v-if="!userCustomShow">
          <span>支付时间：</span>
          <div>{{ userInfo.pay_at ? userInfo.pay_at : "待激活" }}</div>
        </div>
        <div class="orderD" v-if="userInfo.pay_at && !userCustomShow">
          <span>到期时间：</span>
          <div>{{ userInfo.expire_at }}</div>
        </div>
        <div class="orderD" v-else>
          <span>退费实效：</span>
          <span>剩余6天</span>
        </div>
        <div class="orderD" v-if="!userCustomShow">
          <span>备注：</span>
          <el-input type="textarea" v-model="userInfo.remarks"></el-input>
        </div>
        <div class="orderD" v-else>
          <span>备注：</span>
          <el-input type="textarea" v-model="userInfo.remarksTuifei"></el-input>
        </div>
        <div slot="footer" class="dialog-footer" v-if="!userCustomShow">
          <el-button
            :type="userInfo.pay_status == 2 ? 'info' : 'warning'"
            @click="cancelOper"
            size="mini"
            >{{
              userInfo.pay_at
                ? "退费申请"
                : userInfo.pay_status == 2
                ? "已取消"
                : "取消订单"
            }}</el-button
          >
          <el-button type="primary" @click="addUser" size="medium"
            >确 定</el-button
          >
          <el-button @click="addFormShow = false" size="medium"
            >取 消</el-button
          >
        </div>
        <div slot="footer" class="dialog-footer" v-else>
          <el-button type="primary" @click="tuifeiAdd" size="medium"
            >提交申请</el-button
          >
          <el-button @click="userCustomShow = false" size="medium"
            >取 消</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import goodsApi from "@/api/goods.js";
import financialApi from "@/api/financial.js";
import { clearObj, copyToClip } from "@/utils/index.js";
import TableComponents from "@/components/TableComponents.vue";
import MyButton from "@/components/MyButton.vue";
export default {
  name: "RefundApplication",
  components: {
    TableComponents,
    MyButton,
  },
  data() {
    return {
      timeChange: 1,
      queryInfo: {
        limit: 10,
        page: 1,
        total: 0,
        status: -1, // 0 带审核 1批准 2不批准
        order_no: "",
        username: "",
        created_start_time: "",
        created_end_time: "",
        // createTime:[]
      },
      allInfo: {
        pay_count: "",
        pay_fee: "",
        refund_fee: "",
      },
      columns: [
        //列数据
        { label: "订单号", prop: "order_no" },
        { label: "学员账号", prop: "pm_user_id" },
        { label: "手机号", prop: "useMobile" },
        { label: "商品名称", prop: "good_name" },
        { label: "退款原因", prop: "remarks" },
        { label: "状态", prop: "tuikuanStatus" },
        { label: "申请时间", prop: "created_at" },
        { label: "申请操作人", prop: "add_user" },
        { label: "审核时间", prop: "refund_at" },
        // { label: "操作", prop: "operation" },
      ],
      tableFunction: {
        checkData: 0, //是否允许勾选
      },
      tableList: [],
      subject_cate_ids: [],

      columnsCourse: [
        { label: "序号", prop: "serial" },
        { label: "课程名称", prop: "name" },
        { label: "试听", prop: "operation" },
      ],
      tableCourse: [],
      tableFunctionCourse: {
        height: 360,
      },
      // 新增编辑表单数据
      addFormShow: false,
      userShow: false,
      userInfo: {
        qgroup: {
          name,
        },
        remarks: "",
        remarksTuifei: "",
      },
      rules: {
        line_price: [
          { required: true, message: "请输入划线价格", trigger: "blur" },
        ],
        good_price: [
          { required: true, message: "请输入价格", trigger: "blur" },
        ],
      },
      userCustomShow: false,
      timeFrame: [],
      subjectOptions: [],
    };
  },
  computed: {
    dialogType() {
      return "订单详情";
    },
    isSalespersonr() {
      //  this.$store.state.user.userInfo.role,this.$store.state.user.userInfo.role == 'salespersonr');
      return this.$store.state.user.userInfo.role == "salespersonr";
    },
  },
  watch: {
    addFormShow: {
      handler(_newVal) {
        if (!_newVal) {
          clearObj(this.userInfo);
        }
      },
    },
    timeFrame: {
      handler(_newVal) {
        if (!_newVal) {
          this.timeFrame = [];
        }
      },
      deep: true,
    },
  },
  created() {
    if (this.$route.query.order) {
      this.queryInfo.order_no = this.$route.query.order;
    }
    this.getTobOpenExams();
    this.queryTable();
  },
  methods: {
    async getTobOpenExams() {
      const res = await goodsApi.getTobOpenExams(this.queryInfo);
      if (res.code == 200) {
        console.log("getTobOpenExams---", res.data);
        this.subject_cate_ids = [];
        this.subjectOptions = res.data.subject_cate_list;
        res.data.subject_cate_list.forEach((item) => {
          this.subject_cate_ids.push(item.key);
        });
      }
    },

    // 列表数据
    async queryTable(_type) {
      if (_type) {
        this.queryInfo.page = 1;
      }
      this.queryInfo.subject_cate_ids = this.subject_cate_ids.toString();
      const res = await financialApi.refundList(this.queryInfo);
      //  res);
      if (res.code == 200) {
        this.queryInfo.total = res.data.total;
        this.tableList = res.data.data;
        // this.allInfo = res.data
        this.tableList.forEach((item, index) => {
          this.tableList[index].finType = item.type == 1 ? "支出" : "收入";
          let _noti = "";
          switch (item.good_type) {
            case 3:
              _noti = "做题会员卡";
              break;
            case 4:
              _noti = "购买课程";
              break;
            case 6:
              _noti = "学籍卡类型";
              break;
            case 10:
              _noti = "vip学员";
              break;
            case 11:
              _noti = "svip学员卡";
              break;
          }
          // let _payStatus = ''
          // switch (item.status) {
          //   case 0:
          //     _payStatus = '待审核'
          //     break
          //     case 1:
          //     _payStatus = '已通过'
          //     break
          //     case 2:
          //     _payStatus = '未通过'
          //     break
          // }
          this.tableList[index].order_no =
            this.tableList[index].qorder.order_no;
          this.tableList[index].pm_user_id = this.tableList[index].username;

          this.tableList[index].useMobile = this.tableList[index].qorder.mobile;
          // this.tableList[index].userext.mobile;

          this.tableList[index].good_name =
            this.tableList[index].qorder.good_name;
          this.tableList[index].tuikuanStatus = item.status;
        });
        //  this.tableList);
         
        if(res.data.can_operate){
          this.columns.push({ label: "操作", prop: "operation" })
        }
        console.log("this.tableList", res.data.can_operate, this.tableList);
      }
    },
    // // 打开弹窗
    async viewDetail(row, _type) {
      this.userShow = _type;
      Object.assign(this.userInfo, row);
      //  this.userInfo);
      // const res = await goodsApi.courseDetail({id:row.id})
      // if(res.code == 200){
      this.addFormShow = true;
      //   this.userInfo = res.data
      //   this.userInfo.cover_small = row.cover_small
      //   this.userInfo.price = row.price
      //   this.userInfo.id = row.id
      //   this.tableCourse = this.userInfo.data[0].son_chapter_list
      //    'this.userInfo',this.userInfo);
      // }
    },

    // 取消订单 ｜｜ 退费申请
    async cancelOper() {
      if (this.userInfo.pay_at) {
        this.userCustomShow = true;
      } else {
        //  this.userInfo);
        let _obj = {
          id: this.userInfo.id,
        };
        if (!this.userInfo.pay_at) {
          //取消订单
          _obj.status = 2;
        }
        const res = await financialApi.cancelOrder(_obj);
        if (res.code == 200) {
          this.addFormShow = false;
          this.queryTable();
        } else {
          this.$message.error(res.message);
        }
      }
    },
    async addUser() {
      //  this.userInfo);
      let _obj = {
        id: this.userInfo.id,
        remarks: this.userInfo.remarks,
      };
      const res = await financialApi.cancelOrder(_obj);
      if (res.code == 200) {
        this.addFormShow = false;
        this.queryTable();
      } else {
        this.$message.error(res.message);
      }
    },
    // 提交退费申请
    async tuifeiAdd() {
      //  this.userInfo);
      let _obj = {
        id: this.userInfo.id,
        remarks: this.userInfo.remarksTuifei,
      };
      const res = await financialApi.refundOrder(_obj);
      if (res.code == 200) {
        this.addFormShow = false;
        this.userCustomShow = false;
        this.queryTable();
      } else {
        this.$message.error(res.message);
      }
    },
    // // 添加｜｜修改数据
    // addUser(formName){
    //   this.$refs[formName].validate(async (valid) => {
    //     if (valid) {
    //       let _obj = {
    //         type:1,
    //         price:~~this.userInfo.good_price,
    //         line_price:~~this.userInfo.line_price,
    //         relation_id:this.userInfo.id
    //       }
    //        '_____obj____',_obj);
    //       const res = await goodsApi.updateGoodsPrice(_obj)
    //       if(res.code==200){
    //         this.$message.success("修改成功!")
    //         this.addFormShow = false
    //         this.queryTable()
    //       }
    //     } else {
    //        'error submit!!');
    //       return false;
    //     }
    //   });
    // },
    // // 删除数据
    // deleteData(row){
    //   this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     this.$message({
    //       type: 'success',
    //       message: '删除成功!'
    //     });
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: '已取消删除'
    //     });
    //   });
    // },
    // editCode(formName){
    //   this.$refs[formName].validate((valid) => {
    //     if (valid) {
    //       alert('修改成功!');
    //       this.resetCodeShow = false
    //     } else {
    //        'error submit!!');
    //       return false;
    //     }
    //   });
    // },
    // 分页
    handleSizeChange(e) {
      //  e);
      this.queryInfo.limit = e;
      this.queryTable();
    },
    handleCurrentChange(e) {
      this.queryInfo.page = e;
      this.queryTable();
    },
    // 重置
    resetQuery() {
      this.timeFrame = [];
      this.queryInfo = {
        limit: 10,
        page: 1,
        total: 0,
        status: -1, // 0 带审核 1批准 2不批准
        order_no: "",
        username: "",
        created_start_time: "",
        created_end_time: "",
        // createTime:[]
      };
      this.subject_cate_ids = [];
      this.subjectOptions.forEach((item) => {
        this.subject_cate_ids.push(item.key);
      });
      this.queryTable();
    },

    // 日期查询
    selectData(e) {
      if (e) {
        this.queryInfo.created_start_time = e[0];
        this.queryInfo.created_end_time = e[1];
      } else {
        this.queryInfo.created_start_time = "";
        this.queryInfo.created_end_time = "";
      }
    },

    skipFinal(row) {
      if (this.isSalespersonr) {
        this.$message.error("暂无权限！");
        return;
      }
      this.$router.push({
        path: "/financialManage",
        query: {
          order_no: row.qorder.order_no,
          type: 1,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.basicStyle {
  span {
    display: inline-block;
  }
  .querySearch {
    .searchItem {
      display: inline-block;
      margin: 0 20px 10px 0;
      span {
        margin-right: 10px;
        font-size: 14px;
        padding: 5px 0;
      }
      /deep/ .el-input {
        width: 250px;
        padding: 5px 0;
      }
    }
    /deep/ .el-button--primary {
      // margin-left: 50px;
    }
  }
  .addInfo {
    margin: 20px 0;
  }

  // 表格数据
  .table {
    min-height: calc(100vh - 330px);
  }
  .operationItem {
    display: inline-block;
    margin: 0 5px;
    cursor: pointer;
    color: rgb(87, 87, 239);
  }

  // 分页
  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px;
  }

  /deep/ .formDialog {
    .courseDetail {
      img {
        width: 200px;
      }
      .couseUl {
        text-decoration: none;
        height: 400px;
        overflow: auto;
        margin-top: 20px;
        li {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .sellPriceType {
          background-color: rgb(89, 89, 246);
          color: #fff;
          margin: 0 25px;
          border-radius: 10px;
        }
      }
    }
    .userInfoFormStyle {
      display: flex;
      line-height: 40px;
      margin-bottom: 15px;
      .t1 {
        padding: 0 12px 0 0;
        width: 100px;
        box-sizing: border-box;
        text-align: right;
      }
      .t2 {
      }
      .t3 {
      }
    }
    .el-select .el-input {
      width: 180px;
    }
    .el-input {
      width: 250px;
    }
    .dialog-footer {
      text-align: center;
    }
    .roleStyle {
      .el-form-item__content {
        display: flex;
        align-items: center;
        .el-form-item__content {
          margin-left: 0 !important;
        }
        img {
          width: 20px;
          height: 20px;
          margin-left: 10px;
          cursor: pointer;
        }
        .el-button {
          border: none;
          padding-left: 5px;
        }
        .el-button:focus,
        .el-button:hover {
          background-color: #fff;
        }
      }
    }
  }
}

h5 {
  text-align: right;
  margin-right: 20px;
  margin-top: 20px;
  span {
    color: red;
  }
}
// 步骤条

.orderD {
  display: flex;
  margin-bottom: 15px;
  line-height: 40px;
  span {
    display: inline-block;
    width: 100px;
    text-align: center;
  }
  div {
    flex: 1;
    background-color: rgb(222, 222, 222);
    border-radius: 10px;
    color: #000;
    text-align: center;
  }
}
</style>
